module.exports = __webpack_public_path__ + "static/media/computer-science-short-intro.180a283f.jpg";